import { useMemo } from 'react';

import { userRoleList,UserRoles, UserRoleTitles } from './constants';

interface Props {
  omitValues?: (typeof UserRoles)[keyof typeof UserRoles][];
}

export const useRoleOptions = (props?: Props) => {
  const omitValues = props?.omitValues ?? [];

  const omitValuesMap = omitValues.reduce(
    (acc, val) => ({ ...acc, [val]: true }),
    {} as { [key: string]: boolean },
  );

  const roleOptions = useMemo(
    () =>
      userRoleList
        .filter((role) => !omitValuesMap[role])
        .map((role) => ({ title: UserRoleTitles[role], value: role })),
    [omitValues],
  ) as { title: string; value: typeof UserRoles[keyof typeof UserRoles] }[];

  return {
    roleOptions,
    roleOptionsWithAny: [
      { title: 'Any', value: null },
      ...roleOptions,
    ],
  };
};